import './phone-input.scss';

import { toLocalDigits, toZAPhone } from '../../../utils/phone/phone';

export const PhoneInput = ({ value, onChange, hasError = false, className = '' }) => {
  const localDigits = toLocalDigits(value);

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
    onChange(toZAPhone(digits));
  };

  return (
    <div className={`phone-input ${hasError ? 'phone-input--error' : ''} ${className}`}>
      <span className="phone-input__prefix">+27</span>
      <input
        type="tel"
        className="phone-input__field"
        placeholder="82 000 0000"
        value={localDigits}
        onChange={handleChange}
      />
    </div>
  );
};
